"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainBuilder = void 0;
var abstract_builder_1 = require("./abstract-builder");
var domain_1 = require("../structs/domain");
var DomainBuilder = (function (_super) {
    __extends(DomainBuilder, _super);
    function DomainBuilder() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.Model = domain_1.Domain;
        return _this;
    }
    Object.defineProperty(DomainBuilder.prototype, "id", {
        get: function () {
            return this.data.id;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setId = function (id) {
        this.data.id = id;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "name", {
        get: function () {
            return this.data.name;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setName = function (name) {
        this.data.name = name;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "accountId", {
        get: function () {
            return this.data.accountId;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setAccountId = function (accountId) {
        this.data.accountId = accountId;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "accountName", {
        get: function () {
            return this.data.accountName;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setAccountName = function (accountName) {
        this.data.accountName = accountName;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "accountFlags", {
        get: function () {
            return this.data.accountFlags;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setAccountFlags = function (accountFlags) {
        this.data.accountFlags = Array.from(accountFlags);
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "addedNotificationQueryParams", {
        get: function () {
            return this.data.addedNotificationQueryParams;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setAddedNotificationQueryParams = function (addedNotificationQueryParams) {
        this.data.addedNotificationQueryParams = addedNotificationQueryParams;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "collapseKeyType", {
        get: function () {
            return this.data.collapseKeyType;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setCollapseKeyType = function (collapseKeyType) {
        this.data.collapseKeyType = collapseKeyType;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "createdAt", {
        get: function () {
            return this.data.createdAt;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setCreatedAt = function (createdAt) {
        this.data.createdAt = createdAt;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "createdBy", {
        get: function () {
            return this.data.createdBy;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setCreatedBy = function (createdBy) {
        this.data.createdBy = createdBy;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "createdByUsername", {
        get: function () {
            return this.data.createdByUsername;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setCreatedByUsername = function (createdByUsername) {
        this.data.createdByUsername = createdByUsername;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "currency", {
        get: function () {
            return this.data.currency;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setCurrency = function (currency) {
        this.data.currency = currency;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "currencyCode", {
        get: function () {
            return this.data.currencyCode;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setCurrencyCode = function (currencyCode) {
        this.data.currencyCode = currencyCode;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "defaultBadgeUrl", {
        get: function () {
            return this.data.defaultBadgeUrl;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setDefaultBadgeUrl = function (defaultBadgeUrl) {
        this.data.defaultBadgeUrl = defaultBadgeUrl;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "defaultIconUrl", {
        get: function () {
            return this.data.defaultIconUrl;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setDefaultIconUrl = function (defaultIconUrl) {
        this.data.defaultIconUrl = defaultIconUrl;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "defaultNotificationActionLabels", {
        get: function () {
            return this.data.defaultNotificationActionLabels;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setDefaultNotificationActionLabels = function (defaultNotificationActionLabels) {
        this.data.defaultNotificationActionLabels = defaultNotificationActionLabels;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "defaultNotificationActions", {
        get: function () {
            return this.data.defaultNotificationActions;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setDefaultNotificationActions = function (actions) {
        this.data.defaultNotificationActions = !actions ? null : Array.from(actions);
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "defaultNotificationTtlSeconds", {
        get: function () {
            return this.data.defaultNotificationTtlSeconds;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setDefaultNotificationTtlSeconds = function (defaultNotificationTtlSeconds) {
        this.data.defaultNotificationTtlSeconds = defaultNotificationTtlSeconds;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "deliveryThrottleMaxSeconds", {
        get: function () {
            return this.data.deliveryThrottleMaxSeconds;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setDeliveryThrottleMaxSeconds = function (seconds) {
        this.data.deliveryThrottleMaxSeconds = seconds;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "displayMeta", {
        get: function () {
            return this.data.displayMeta;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setDisplayMeta = function (displayMeta) {
        this.data.displayMeta = displayMeta;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "displayName", {
        get: function () {
            return this.data.displayName;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setDisplayName = function (displayName) {
        this.data.displayName = displayName;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "domainKey", {
        get: function () {
            return this.data.domainKey;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setDomainKey = function (domainKey) {
        this.data.domainKey = domainKey;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "ecommConfig", {
        get: function () {
            return this.data.ecommConfig;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setEcommConfig = function (ecommConfig) {
        this.data.ecommConfig = ecommConfig;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "fcmServerKey", {
        get: function () {
            return this.data.fcmServerKey;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setFcmServerKey = function (fcmServerKey) {
        this.data.fcmServerKey = fcmServerKey;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "flags", {
        get: function () {
            return this.data.flags;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setFlags = function (flags) {
        this.data.flags = Array.from(flags);
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "frequencyCaps", {
        get: function () {
            return this.data.frequencyCaps;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setFrequencyCaps = function (frequencyCaps) {
        this.data.frequencyCaps = frequencyCaps;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "globalPromptSettings", {
        get: function () {
            return this.data.globalPromptSettings;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setGlobalPromptSettings = function (globalPromptSettings) {
        this.data.globalPromptSettings = globalPromptSettings;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "landingUrlDomainWhitelist", {
        get: function () {
            return this.data.landingUrlDomainWhitelist;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setLandingUrlDomainWhitelist = function (allowedDomains) {
        this.data.landingUrlDomainWhitelist = Array.from(allowedDomains);
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "mediaQuality", {
        get: function () {
            return this.data.mediaQuality;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setMediaQuality = function (mediaQuality) {
        this.data.mediaQuality = mediaQuality;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "apnsConfiguration", {
        get: function () {
            return this.data.apnsConfiguration;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setApnsConfiguration = function (apnsConfiguration) {
        this.data.apnsConfiguration = apnsConfiguration;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "nativeApnsConfiguration", {
        get: function () {
            return this.data.nativeApnsConfiguration;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setNativeApnsConfiguration = function (nativeApnsConfiguration) {
        this.data.nativeApnsConfiguration = nativeApnsConfiguration;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "nativeFcmConfiguration", {
        get: function () {
            return this.data.nativeFcmConfiguration;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setNativeFcmConfiguration = function (nativeFcmConfiguration) {
        this.data.nativeFcmConfiguration = nativeFcmConfiguration;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "notificationAutoSuggestFields", {
        get: function () {
            return this.data.notificationAutoSuggestFields;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setNotificationAutoSuggestFields = function (fields) {
        this.data.notificationAutoSuggestFields = !fields ? null : Array.from(fields);
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "notificationFrequencyCaps", {
        get: function () {
            return this.data.notificationFrequencyCaps;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setNotificationFrequencyCaps = function (notificationFrequencyCaps) {
        this.data.notificationFrequencyCaps = !notificationFrequencyCaps ? null : Array.from(notificationFrequencyCaps);
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "prodDomainId", {
        get: function () {
            return this.data.prodDomainId;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setProdDomainId = function (prodDomainId) {
        this.data.prodDomainId = prodDomainId;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "routingKey", {
        get: function () {
            return this.data.routingKey;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setRoutingKey = function (routingKey) {
        this.data.routingKey = routingKey;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "sdkEventOnlyDomains", {
        get: function () {
            return this.data.sdkEventOnlyDomains;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setSdkEventOnlyDomains = function (domains) {
        this.data.sdkEventOnlyDomains = Array.from(domains);
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "senderId", {
        get: function () {
            return this.data.senderId;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setSenderId = function (senderId) {
        this.data.senderId = senderId;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "status", {
        get: function () {
            return this.data.status;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setStatus = function (status) {
        this.data.status = status;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "statusId", {
        get: function () {
            return this.data.statusId;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setStatusId = function (statusId) {
        this.data.statusId = statusId;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "timeZone", {
        get: function () {
            return this.data.timeZone;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setTimeZone = function (timezone) {
        this.data.timeZone = timezone;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "updatedAt", {
        get: function () {
            return this.data.updatedAt;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setUpdatedAt = function (updatedAt) {
        this.data.updatedAt = updatedAt;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "updatedBy", {
        get: function () {
            return this.data.updatedBy;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setUpdatedBy = function (updatedBy) {
        this.data.updatedBy = updatedBy;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "updatedByUsername", {
        get: function () {
            return this.data.updatedByUsername;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setUpdatedByUsername = function (updatedByUsername) {
        this.data.updatedByUsername = updatedByUsername;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "utmParams", {
        get: function () {
            return this.data.utmParams;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setUtmParams = function (utmParams) {
        this.data.utmParams = utmParams;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "vapidPublicKey", {
        get: function () {
            return this.data.vapidPublicKey;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setVapidPublicKey = function (vapidPublicKey) {
        this.data.vapidPublicKey = vapidPublicKey;
        return this;
    };
    Object.defineProperty(DomainBuilder.prototype, "whitelistDomains", {
        get: function () {
            return this.data.whitelistDomains;
        },
        enumerable: false,
        configurable: true
    });
    DomainBuilder.prototype.setWhitelistDomains = function (allowedDomains) {
        this.data.whitelistDomains = !allowedDomains ? null : Array.from(allowedDomains);
        return this;
    };
    return DomainBuilder;
}(abstract_builder_1.AbstractBuilder));
exports.DomainBuilder = DomainBuilder;
//# sourceMappingURL=domain-builder.js.map